import { createListenerMiddleware } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import actionsDispatched from './ActionsDispatched';
import config from './Config';
import productInventory from './ProductInventory';
import abstractedProducts from './Products';
import purchaseMotionsByLocation from './PurchaseMotionsByLocation';
import queryParamTerm from './QueryParamTerm';
import requests from './Requests';
import { upgradePageViewReducer as upgradePageView } from './UpgradePageView';
import auth from './auth';
import requiredOnboarding from './requiredOnboarding';
export const rootReducer = combineReducers({
  auth,
  requiredOnboarding,
  requests,
  actionsDispatched,
  abstractedProducts,
  config,
  purchaseMotionsByLocation,
  queryParamTerm,
  productInventory,
  upgradePageView
});

// This type represents the state of your root reducer,
// and can be useful when creating selectors
export const createAppListenerMiddleware = createListenerMiddleware;

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;